import React, { useEffect, useRef, useState } from "react";
import { motion, useInView, useMotionValue, useSpring } from "framer-motion";
import { api } from "@/lib/api";

const Count = ({ value }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.5 });
  const mv = useMotionValue(0);
  const spring = useSpring(mv, { stiffness: 60, damping: 20 });
  const [txt, setTxt] = useState("0");
  useEffect(() => { if (inView) mv.set(value); }, [inView, value, mv]);
  useEffect(() => spring.on("change", (v) => setTxt(Math.round(v).toLocaleString("fr-FR"))), [spring]);
  return <span ref={ref} className="font-mono-l tabular-nums">{txt}</span>;
};

const LABELS = [
  ["artisans", "artisans inscrits"],
  ["chantiers", "chantiers publiés"],
  ["documents_verifies", "attestations vérifiées"],
  ["metiers", "familles de métiers"],
];

export const Counters = () => {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/public/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);
  const items = stats ? LABELS.filter(([k]) => stats[k] != null) : [];
  // Seuil (PUBLIC_STATS_MIN_COUNT côté serveur) : les compteurs sous le seuil
  // arrivent à null → la section disparaît si aucun chiffre n'est crédible.
  if (items.length < 2) return null;
  return (
    <section className="relative bg-[#0F2338] text-white grain overflow-hidden" data-testid="counters-section">
      <div className="max-w-6xl mx-auto px-5 md:px-8 py-16 md:py-24 grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-6">
        {items.map(([k, label], i) => (
          <motion.div key={k} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7, delay: i * 0.1 }}
            className="border-l border-[#E8710A]/60 pl-4 md:pl-6" data-testid={`counter-${k}`}>
            <div className="font-display text-3xl sm:text-4xl lg:text-6xl font-semibold tracking-tight text-white"><Count value={stats[k]} /></div>
            <div className="font-body-l mt-2 text-xs md:text-sm uppercase tracking-[0.18em] text-white/60">{label}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
